import type { FC } from "react";

import {
  SELECT_DEFAULTS,
  type TSelectProps,
} from "@/ui/components/form/Select/Select.config";
import { SelectContent } from "@/ui/components/form/Select/SelectContent";
import { SelectItem } from "@/ui/components/form/Select/SelectItem";
import { SelectRoot } from "@/ui/components/form/Select/SelectRoot";
import { SelectTrigger } from "@/ui/components/form/Select/SelectTrigger";
import { SelectValue } from "@/ui/components/form/Select/SelectValue";
import { FieldWrapper } from "@/ui/components/form/shared";

export const Select: FC<TSelectProps> = (
  {
    className,
    contentClassName,
    disabled,
    error,
    id,
    label,
    hideLabel,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    options,
    placeholder = SELECT_DEFAULTS.placeholder,
    triggerClassName,
    asChild,
    ...props
  },
) => (
  <FieldWrapper
    componentName="Select"
    className={className}
    disabled={disabled}
    error={error}
    hideLabel={hideLabel}
    label={label}
    required={props.required}
    asChild={asChild}
  >
    <SelectRoot {...props} disabled={disabled}>
      <SelectTrigger
        id={id}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        error={error}
        disabled={disabled}
        className={triggerClassName}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className={contentClassName}>
        { options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
            icon={option.icon}
          >
            { option.label }
          </SelectItem>
        )) }
      </SelectContent>
    </SelectRoot>
  </FieldWrapper>
);

Select.displayName = "Select";
